module.exports = __webpack_public_path__ + "img/ilifestyle_bg.d3d45895.jpg";